import { useRootStore } from 'stores/RootStore'

export const useIsActiveOrCanceledPioneerPlan = () => {
  const { currentSubscription } = useRootStore().tierUsageStore

  const isCanceledOrActivePioneerPlan =
    currentSubscription?.status === 'active' ||
    (currentSubscription?.status === 'canceled' && !currentSubscription?.trial_ended)

  return isCanceledOrActivePioneerPlan
}
